import { deleteReq, get, post, put } from './index';

export interface ManagedUser {
  id: number;
  username: string;
  name: string;
  role_id: number;
  role_name: string;
}

/**
 * 用户登录
 */
export const login = (data: { username: string; password: string }) => {
  return post<Record<'name' | 'username' | 'token', string>>({
    url: '/user/login',
    data,
  });
};

export const addUser = (data: {
  username: string;
  name: string;
  password: string;
  role_id: number;
}) => {
  return post({
    url: '/user/add',
    data,
  });
};

export const changePassword = (data: {
  current_password: string;
  new_password: string;
}) => {
  return put({
    url: '/user/password',
    data,
  });
};

export const generateApiKey = () => {
  return post<{ api_key: string }>({
    url: '/user/api-key',
  });
};

export const getManagedUsers = (keyword = '') => {
  return get<{ users: ManagedUser[] }>({
    url: '/manager/user',
    params: { keyword },
  });
};

export const addManagedUser = (data: {
  username: string;
  name: string;
  password: string;
}) => {
  return post({
    url: '/manager/user',
    data: { ...data, role_id: 2 },
  });
};

export const deleteManagedUser = (id: number) => {
  return deleteReq({
    url: `/manager/user/${id}`,
  });
};

export const resetManagedUserPassword = (
  id: number,
  data: { new_password: string }
) => {
  return put({
    url: `/manager/user/${id}/password`,
    data,
  });
};
